import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ServiceTypeSelectButton from '@/components/Ui/ServiceTypeSelectButton'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ScreenIdMst',
  components: {
    Loading,
    ServiceTypeSelectButton,
  },
  metaInfo () {
    let title = this.categoryName + 'マスタ | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'screenId',
        'screenName',
        'serviceTypes',
        'screenTransitionFlg',
        'screenIdStatus',
        'modifyButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          screenId: '固定画面ID',
          screenName: '固定画面名',
          serviceTypes: 'サービスタイプ',
          screenTransitionFlg: '画面遷移対応',
          screenIdStatus: 'ステータス',
          modifyButton: ''
        },
        columnsClasses: {
          screenId: 'wp-5',
          screenName: '',
          serviceTypes: '',
          screenTransitionFlg: '',
          screenIdStatus: '',
          modifyButton: 'wp-5 has-button'
        },
        sortable: [
          'screenId',
          'screenName',
          'serviceTypes',
          'screenTransitionFlg',
          'screenIdStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.screenIdMst.categoryName,
      screenIdMstModel: state => state.screenIdMst.screenIdMstModel,
      // form
      values: state => state.screenIdMst.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'screenIdMst/isRegister',
      isModify: 'screenIdMst/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.screenIdMstModel, 'screenIdMstUuid', this.modifyTargetId, 'screenId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpScreenId: {
      get () {
        return this.values.inpScreenId
      },
      set (value) {
        this.setInputValue({
          key: 'inpScreenId',
          value: value
        })
      }
    },
    inpScreenName: {
      get () {
        return this.values.inpScreenName
      },
      set (value) {
        this.setInputValue({
          key: 'inpScreenName',
          value: value
        })
      }
    },
    inpServiceTypes: {
      get () {
        return this.values.inpServiceTypes
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceTypes',
          value: value
        })
      }
    },
    inpTransitionFlag: {
      get () {
        return this.values.inpTransitionFlag
      },
      set (value) {
        this.setInputValue({
          key: 'inpTransitionFlag',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // validate
    inpScreenIdIsValid () {
      return Validator.validText(this.inpScreenId)
    },
    inpScreenNameIsValid () {
      return Validator.validText(this.inpScreenName)
    },
    inpServiceTypesIsValid () {
      return Validator.validSelect(this.inpServiceTypes)
    },
    inpStatusIsValid () {
      return Validator.validSelect(this.inpStatus)
    },
    formIsValid () {
      return this.inpScreenIdIsValid &&
        this.inpScreenNameIsValid &&
        this.inpServiceTypesIsValid &&
        this.inpStatusIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'screenIdMst/loadModel',
      initRegister: 'screenIdMst/initRegister',
      initModify: 'screenIdMst/initModify',
    }),
    ...mapMutations({
      setInputValue: 'screenIdMst/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let screenIdMstParams = {}

      // データ読出し
      this.loadModel({
        screenIdMstParams: screenIdMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.screenIdMstModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.screenIdMstModel, 'screenIdMstUuid', this.modifyTargetId, 'linkedCmsMstId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true
      // console.log(this.isModify)
      let parameters = {
        request: {
          screenId: this.inpScreenId,
          screenName: this.inpScreenName,
          serviceTypeCds: this.inpServiceTypes.map(item => item.serviceTypeCd),
          screenTransitionFlg: this.inpTransitionFlag,
          screenIdStatus: this.inpStatus
        }
      }
      // if (this.inpTransitionFlag) {
      //   parameters.request.screenTransitionFlg = this.inpTransitionFlag
      // }
      if (this.isModify) {
        parameters.screenIdMstUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['screenIdMst'],
        [this.isRegister ?
          'v1ScreenIdMstPost' :
          'v1ScreenIdMstPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'serviceTypes':
          return value.length
            ? value.map(item => item.serviceTypeName).join('、')
            : ''
        case 'screenTransitionFlg':
          return Utility.getConstantsLabel(['Mst', 'ButtonEnabled'], value)
        case 'screenIdStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    /**
     * サービスタイプの変更
     */
    changeServiceTypeValue (props) {
      console.log(props)
      // this.inpServiceTypes = props.data
      this.$set(this, 'inpServiceTypes', props.data)
    },

    registerItem () {
      this.modifyTargetId = null
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.screenIdMstUuid
      this.initModify({
        data: props.row
      })
    },
  }
}